import React, { useState, useEffect } from 'react';
import { LISTING_TYPE } from '../platformUtils';
import { createClient } from "@supabase/supabase-js";


function useGetListings() {
    const [listings, setListings] = useState([]);
    // TODO: get a specific property and metadata data from Moralis / backend / tbd with the given NFT address and token Id 
    const supabase = createClient(
        `https://${process.env.REACT_APP_SUPABASE_URL}.supabase.co`,
        `${process.env.REACT_APP_SUPABASE_API_KEY}`
      );

      useEffect(()=> {
        const getListings = async () => {
            try {
                let { data, error, status } = await supabase
                .from("listings")
                .select() 
                .eq("listing_public", true)
                
              if (error && status !== 406) {
                throw error;
              }
              if(data) {setListings(data);};
              if (status) {
                console.log("Database status: ", status);
              }
            } catch (error) {
              console.table(error);
            }
          };
          getListings();
      }, [])
 
    return listings;
}

export default useGetListings;